import React from 'react'
import { Box, Button, Flex, Image, Grid } from '@chatterbug/aaron'
import PropTypes from 'prop-types'

import { NUDGE_TYPES } from './NudgeCardContentData'
import NudgeCardBody from './NudgeCardBody'

const NudgeCardContent = ({ type, imageUrl, nudgeUrl }) => {
  const cardInfo = NUDGE_TYPES[type]

  return (
    <Grid
      gridGap={{ _: '3x' }}
      columns={{ _: '1fr', tablet: 'repeat(2, 1fr)' }}
    >
      <Flex
        justifyContent="center"
        alignItems={{ _: '', tablet: 'flex-start' }}
        flexDirection="column"
      >
        <Box as="h3" variant="text.h3" mb="2x">
          {cardInfo.titleText}
        </Box>
        <NudgeCardBody text={cardInfo.bodyText} />
      </Flex>
      <Flex
        justifyContent="center"
        alignItems="center"
        gridRow={{ _: cardInfo.imageFirst ? '1' : '2', tablet: 'span 2' }}
      >
        <Image
          width={{
            mobile: !cardInfo.imageFirst ? '100%' : 'auto',
            tablet: '100%',
          }}
          maxHeight={type === 'subscribe' || 'set_goals' ? '247px' : '170px'}
          src={imageUrl || cardInfo.imageUrl}
          alt=""
        />
      </Flex>
      <Box>
        <Box width={{ _: '100%', tablet: 'fit-content' }}>
          <Button
            as="a"
            href={nudgeUrl}
            type={cardInfo.buttonType}
            width="100%"
          >
            {cardInfo.buttonText}
          </Button>
        </Box>
      </Box>
    </Grid>
  )
}

NudgeCardContent.propTypes = {
  imageUrl: PropTypes.string,
  nudgeUrl: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'schedule',
    'review_live_lesson',
    'subscribe',
    'set_goals',
  ]).isRequired,
}

export default NudgeCardContent
